export default {
  "content": "<path fill=\"#333\" d=\"M0 29.729a2.5 2.5 0 012.5-2.5h27a2.5 2.5 0 010 5h-27a2.5 2.5 0 01-2.5-2.5z\" opacity=\".3\"/><path fill=\"#333\" stroke=\"#333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.592 23.701l4.48.004.89-.838-2.243-2.115-3.127 2.95z\"/><path fill=\"#333\" d=\"M30.03 8.066c.52-.52.52-1.36 0-1.88l-4.535-4.534c-.52-.52-1.36-.52-1.88 0l-2.613 2.613 6.414 6.414 2.613-2.613zm-3.91 3.979l-6.48-6.419-10.575 10.52-.741 4.973c-.392.39-.47.942-.176 1.233l1.17 1.12c.294.291.85.212 1.242-.177l4.954-.7 10.605-10.55z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "32",
    "fill": "none",
    "viewBox": "0 0 32 32"
  }
};